import AppDataService from "./AppDataService";

const COMMON_BASE = 'Common'

export default class CommonDataService {
    static async uploadAttachment(source, data, commonBase) {
        return await AppDataService.post(`${commonBase}/UploadAttachment?source=${source}`, data)
    }
}